import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: true
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
